import { useState, useCallback } from 'react';

export const STAGES = {
  UPLOAD: 'upload',
  MAP: 'map',
  VALIDATE: 'validate',
  RESULTS: 'results',
};

const STAGES_ORDER = [STAGES.UPLOAD, STAGES.MAP, STAGES.VALIDATE, STAGES.RESULTS];

export const useUpload = ({ propertiesMap }) => {
  const [stage, setStage] = useState(STAGES.UPLOAD);
  const [headers, setHeaders] = useState([]);
  const [properties, setProperties] = useState(headers);
  const [fileData, setFileData] = useState([]);
  const [mappedData, setMappedData] = useState([]);
  const [results, setResults] = useState([]);

  const showResults = useCallback(results => {
    setResults(results);
    setStage(STAGES.RESULTS);
  }, []);

  const goBack = useCallback(() => {
    const currentIndex = STAGES_ORDER.indexOf(stage);
    if (currentIndex > 0) {
      setStage(STAGES_ORDER[currentIndex - 1]);
    }
  }, [stage]);

  const handleFileUpload = useCallback(({ headers, rows }) => {
    setHeaders(headers);
    setFileData(rows);
    setStage(STAGES.MAP);
  }, []);

  const mapFileHeadersToUserProperties = useCallback(
    mappings => {
      setProperties(Object.values(mappings));
      const mapped = fileData.map(row => {
        const rowData = {};
        Object.entries(mappings).forEach(([header, property]) => {
          let fieldFileData = row[headers.indexOf(header)];
          if (property === 'email') {
            fieldFileData = fieldFileData?.trim()?.toLowerCase();
          }

          const professionalField = propertiesMap[property];

          if (professionalField?.multiple) {
            // Split the field data by comma and trim each item
            const fieldFileDataArray = fieldFileData?.split(',').map(item => item.trim()) || [];

            // If the property is not an array, initialize it as an array
            if (!Array.isArray(rowData[property])) {
              rowData[property] = [];
            }

            fieldFileDataArray.forEach(item => {
              rowData[property].push(
                professionalField && professionalField.findMatch
                  ? professionalField.findMatch?.(item)
                  : item,
              );
            });
            return;
          }

          rowData[property] =
            professionalField && professionalField.findMatch
              ? professionalField.findMatch(fieldFileData)
              : fieldFileData;
        });
        return rowData;
      });
      setMappedData(mapped);
      setStage(STAGES.VALIDATE);
    },
    [fileData, headers],
  );

  return {
    stage,
    setStage,
    headers,
    fileData,
    properties,
    mappedData,
    handleFileUpload,
    mapFileHeadersToUserProperties,
    goBack,
    results,
    showResults,
    propertiesMap,
  };
};
